import { useEffect, useState } from "react";
import { addMember, deleteMember, editMember, editMemberImage, fetchMemberByID, fetchMemberImageURL, queryNamesAllMembers } from "../contexts/fetchDBMembers";
import { Button, Col, Form, Row } from "react-bootstrap";
import { AddModal, EditImageModal, EditModal } from "./Modals";

const memberAddingStructure = [
    {
        title: "Title",
        type: "text",
        field: "title",
        init: "",
    },
    {
        title: "First Name",
        type: "text",
        field: "firstname",
        init: "",
    },
    {
        title: "Last Name",
        type: "text",
        field: "lastname",
        init: "",
    },
    {
        title: "SG Name (for Singaporeans only!)",
        type: "text",
        field: "sgname",
        init: "",
    },
    {
        title: "Name in your language (optional)",
        type: "text",
        field: "ownlanguage",
        init: "",
    },
    {
        title: "Nationality (sg/cn/ru/in/vn/th/...)",
        type: "text",
        field: "nationality",
        init: "",
    },
    {
        title: "Member Type",
        type: "type",
        field: "type",
        init: "",
    },
    {
        title: "Emails",
        type: "array-text",
        field: "email",
        init: [],
    },
    {
        title: "Short Description",
        type: "text",
        field: "shortDescription",
        init: "",
    },
]

const memberEditingStructure = [
    {
        title: "Hidden?",
        type: "switch",
        field: "hidden",
        init: true,
    },
    {
        title: "Name in your language (optional)",
        type: "text",
        field: "ownlanguage",
        init: "",
    },
    {
        title: "Nationality (sg/cn/ru/in/vn/th/...)",
        type: "text",
        field: "nationality",
        init: "",
    },
    {
        title: "Member Type",
        type: "type",
        field: "type",
        init: "",
    },
    {
        title: "Emails",
        type: "array-text",
        field: "email",
        init: [],
    },
    {
        title: "Short Description",
        type: "text",
        field: "shortDescription",
        init: "",
    },
    {
        title: "Introduction",
        type: "textarea",
        field: "description",
        init: "",
    },
    {
        title: "Research Fields",
        type: "array-text",
        field: "fields",
        init: [],
    },
    {
        title: "Education Background",
        type: "timeline",
        field: "education",
        init: [],
    },
    {
        title: "Links",
        type: "links",
        field: "links",
        init: [],
    },
    {
        title: "Key Publications",
        type: "publications",
        field: "publications",
        init: [],
    },
    {
        title: "Awards",
        type: "array-text",
        field: "awards",
        init: [],
    },
    {
        title: "Professional Services",
        type: "timeline",
        field: "professionalServices",
        init: [],
    },
]

const memberImageStructure = [
    {
        title: "Image",
        type: "file",
        field: "img",
        init: null,
    },
]


const DBMembers = () => {

    const [names, setNames] = useState({});
    const [eID, setEID] = useState("-");
    const [dID, setDID] = useState("-");
    const [iID, setIID] = useState("-");

    const [eData, setEData] = useState({});
    const [iData, setIData] = useState({ img: "" });

    const [isShowA, setShowA] = useState(false);
    const [isShowE, setShowE] = useState(false);
    const [isShowI, setShowI] = useState(false);

    useEffect(() => {
        queryNamesAllMembers(setNames);
        return () => {
            setNames({});
            setEID("-");
            setDID("-");
            setIID("-");
            setEData({});
            setIData({ img: "" });
            setShowA(false);
            setShowE(false);
            setShowI(false);
        }
    }, []);

    const handleAddSubmit = async (e, formData) => {
        e.preventDefault();
        try {
            await addMember(formData);
            await queryNamesAllMembers(setNames);
            setShowA(false);
        } catch (error) {
            console.error("Error in handleAddSubmit:", error);
        }
    };

    const handleEditSubmit = async (e, formData) => {
        e.preventDefault();
        try {
            delete formData.id
            await editMember(eID, formData)
            setShowE(false);
        } 
        catch (error) {
            console.error("Error in handleEditSubmit:", error);
        }
    };

    const handleEditImageSubmit = async (e, formData) => {
        e.preventDefault();
        try {
            delete formData.id
            await editMemberImage(iID, formData);
            const img = await fetchMemberImageURL(iID);
            setIData({ img })
        } catch (error) {
            console.error("Error in handleEditImageSubmit:", error);
        }
    };

    const handleDeleteSubmit = async () => {
        const confirm = window.confirm("Are you sure you want to delete this item?");
        if (!confirm) return;

        try {
            await deleteMember(dID);
            await queryNamesAllMembers(setNames);
        } catch (error) {
            console.error("Error deleting:", error);
        }
    };

    return (
        <div>
            <Row>
                <Col xs='12' sm='3' lg='2'>Add member</Col>
                <Col className="col-auto" />
                <Col className="text-end">
                    <Button onClick={() => setShowA(true)}>Add</Button>
                </Col>
            </Row>
            <hr />
            <Row>
                <Col xs='12' sm='3' lg='2'>Edit member</Col>
                <Col>
                    <Form.Select value={eID} onChange={e => setEID(e.target.value)}>
                        {Object.keys(names).map(key => (
                            <option value={key} key={key}>{names[key]}</option>
                        ))}
                    </Form.Select>
                </Col>
                <Col className="col-auto">
                    <Button variant="warning" onClick={async () => {const d = await fetchMemberByID(eID); setEData(d); console.log(d) ; setShowE(true)}} disabled={eID === "-"}>Edit</Button>
                </Col>
            </Row>
            <hr />
            <Row>
                <Col xs='12' sm='3' lg='2'>Profile Picture</Col>
                <Col>
                    <Form.Select value={iID} onChange={e => setIID(e.target.value)}>
                        {Object.keys(names).map(key => (
                            <option value={key} key={key}>{names[key]}</option>
                        ))}
                    </Form.Select>
                </Col>
                <Col className="col-auto">
                    <Button 
                        variant="secondary" disabled={iID === "-"}
                        onClick={async () => {const img = await fetchMemberImageURL(iID); setIData({ img }) ; setShowI(true)}} 
                    >
                        Modify</Button>
                </Col>
            </Row>
            <hr />
            <Row>
                <Col xs='12' sm='3' lg='2'>Delete member</Col>
                <Col>
                    <Form.Select value={dID} onChange={e => setDID(e.target.value)}>
                        {Object.keys(names).map(key => (
                            <option value={key} key={key}>{names[key]}</option>
                        ))}
                    </Form.Select>
                </Col>
                <Col className="col-auto">
                    <Button variant="danger" onClick={handleDeleteSubmit} disabled={dID === "-"}>Delete</Button>
                </Col>
            </Row>
            <hr />
            <AddModal       isShowM={isShowA} setShowM={setShowA} structure={memberAddingStructure}  onSubmit={handleAddSubmit} />
            <EditModal      isShowM={isShowE} setShowM={setShowE} structure={memberEditingStructure} onSubmit={handleEditSubmit} existingData={eData} size='lg' />
            <EditImageModal isShowM={isShowI} setShowM={setShowI} structure={memberImageStructure}   onSubmit={handleEditImageSubmit} img={iData.img} />
        </div>
    )
}

export default DBMembers;



/**
 * 
 * 18 fields
award
description
education
email
fields
firstname
hidden
index
lastname
links
nationality
ownlanguage
professionalServices
publications
sgname
shortDescription
timestamp
title
type


index
timestamp
hidden

1. title
2. firstname
3. lastname
4. sgname
5. ownlanguage
6. nationality
7. type
8. email
9. shortDescription

10. description
11. education
12. fields
13. links

14. publications
15. awards
16. professionalServices


edit:
5. ownlanguage
6. nationality
7. type
8. email
9. shortDescription

10. description
11. education
12. fields
13. links

14. publications
15. awards
16. professionalServices

ownlanguage, nationality, type, email, 
shortDescription, description, education, fields, 
links, publications, awards, professionalServices, 

 */